import { BaseRepository } from "src/app/infrastructure/BaseRepository";
import stickerResource from "../resources/StickerResource";

class StickerItemRepository extends BaseRepository {
  constructor() {
    super(stickerResource)
  }

  public attachStickerToCurrentUser(sticker) {
    return this.resource(sticker, 'set_my_llama')
      .create()
      .then((res) => this.processResponse(res));
  }

  // public canCurrentUserWriteInSticker(sticker, access_token?) {
  //   return this.resource(sticker, 'ask_write_access')
  //     .create({ access_token })
  //     .then((res) => this.processResponse(res));
  // }

  public cleanSticker(stickerId: string) {
    return this.resource(stickerId, 'clean')
        .create()
        .then((res) => this.processResponse(res));
  }
}

const stickerRepository = new StickerItemRepository();

export default stickerRepository;



// WEBPACK FOOTER //
// ./src/app/modules/stickers/domain/repositories/StickerRepository.ts